import React, { useState } from "react";
import API from "../utils/api";
import { useNavigate } from "react-router-dom";
import FlashMessage from "./FlashMessage";
import "../styling/login.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flashType, setFlashType] = useState("success");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post("/auth/forgot-password", { email });
      if (res.status === 200) {
        setFlashType("success");
        setFlashMessage("Reset link sent! Check your email.");
        setTimeout(() => navigate("/login"), 2500);
      }
    } catch (err) {
      setFlashType("error");
      setFlashMessage("Error sending reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <FlashMessage message={flashMessage} type={flashType} duration={3000} onClose={() => setFlashMessage("")} />
      <div className="login-card">
        <h2>Reset Password</h2>
        <p className="login-subtitle">Enter your email and we'll send you a reset link</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={loading} className="btn btn-primary btn-block">
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
        <p className="forgot-password" onClick={() => navigate("/login")}>← Back to login</p>
      </div>
    </div>
  );
};

export default ForgotPassword;
